import React, { act, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import moment from "moment";
import { betCheckObj, removeSPrefix } from "../../Utils/Toast";
import { useTabIndicator } from "../../component/useTabIndicator";
import MyBetsSingleVelkie from "./MyBetSingleVelkie";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const MyBetsVelkie = () => {
  const showBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.showBets;
  });
  const setShowBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowBets;
  });
  const [parly, setParly] = useState([]);
  const [data, setData] = useState([]);
  const [activeParlay, setActiveParlay] = useState([]);
  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  const [activeTab, setActiveTab] = useState("exchange");
  const tabs = [
    { id: "exchange", label: "Exchange" },
    { id: "parlay", label: "Parlay" },
  ];
  const [matched, setMatched] = useState(true);
  const [active, setActive] = useState([]);
  const [show, setShow] = useState(true);
  const handle = (id) => {
    if (Array.isArray(id)) {
      // If id is an array
      const allExist = id.every((item) => active.includes(item));

      if (allExist) {
        // If all IDs exist → remove them
        setActive(active.filter((res) => !id.includes(res)));
      } else {
        // Otherwise → add missing IDs
        const newIds = id.filter((item) => !active.includes(item));
        setActive([...active, ...newIds]);
      }
    } else {
      // If id is a single value → toggle like before
      if (active.includes(id)) {
        setActive(active.filter((res) => res !== id));
      } else {
        setActive([...active, id]);
      }
    }
  };

  const getId = (array) => {
    return array?.flatMap((res) => {
      // Collect all possible lists dynamically
      const lists = [
        "betList",
        "sessionBetList",
        "sportBookBetList",
        "bookmakerList",
      ];

      // Extract _ids from each available list
      return lists.flatMap(
        (list) => res?.[list]?.map((item) => item?._id) || []
      );
    });
  };
  const getCurrentBets = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.mobileCurrentBets
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users?.results?.length > 0) {
          let find = response_users?.results?.filter((res) => {
            return (
              res?.betList?.length > 0 ||
              res?.bookmakerList?.length > 0 ||
              res?.sessionBetList?.length > 0 ||
              res?.sportBookBetList?.length > 0
            );
          });
          if (find?.length > 0) {
            setData(response_users.results);
            setActive(getId(response_users.results));
          }
        }
      }
    }
  };
  const getParlyBet = async () => {
    const { status, data } = await apiGet(apiPath.getParlyBets);
    if (status == 200) {
      if (data?.success) {
        setParly(data?.results);
        setActiveParlay([]);
      }
    }
  };
  useEffect(() => {
    if (showBets) {
      getCurrentBets();
      getParlyBet();
    }
  }, [showBets]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("by Time");

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleSelect = (value) => {
    setSelected(value);
    setOpen(false);
  };
  const Dropdown = () => {
    return (
      <div className="relative z-20 flex items-center px-6px py-2 w-114px bg-white text-11 rounded-6px shadow-all-button">
        <i className="icon-toggle flex items-center justify-center mr-1 rotate-90 text-11" />
        <button
          className="select text-left w-full text-15"
          onClick={toggleDropdown}
        >
          <div className="flex justify-start items-center">
            <div className="w-full flex justify-start items-center">
              <span className="text-11 whitespace-nowrap">{selected}</span>
            </div>
            <i
              className={`icon-triangle transform text-8 scale-75 transition-transform origin-center duration-300 mx-0.5 ${
                open ? "rotate-180" : ""
              }`}
            />
          </div>
        </button>

        {open && (
          <div className="drop-down w-full left-0 text-15 absolute top-8 -mt-1 z-10">
            <div className="options bg-white flex flex-col rounded-6px rounded-t-none whitespace-nowrap shadow-all-button">
              <p
                className="item flex items-center py-2 px-6 cursor-pointer"
                onClick={() => handleSelect("by Time")}
              >
                <span className="item-text relative text-11">by Time</span>
              </p>
              <p
                className="item flex items-center py-2 px-6 cursor-pointer"
                onClick={() => handleSelect("by Event")}
              >
                <span className="item-text relative text-11">by Event</span>
              </p>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      data-v-925e8870
      style={{
        "--6457ae29": `${indicatorStyle?.width || 77}px`,
        "--2eb90372": `translateX(${indicatorStyle?.x + 90}px)`,
      }}
    >
      <div
        data-v-925e8870
        className="absolute -top-40px w-full h-full z-40 bg-black opacity-30"
        style={{}}
      />
      <div
        data-v-925e8870
        className="mybet fixed z-40 container bottom-0"
        style={{}}
      >
        <div
          data-v-925e8870
          className="mybet-content bg-black flex flex-col h-full overscroll-y-none rounded-t-xl overflow-hidden"
        >
          <div data-v-925e8870 className="shrink-0 bg-secondary rounded-t-xl">
            <header
              data-v-925e8870
              className="mybet-title flex p-1 py-2 h-40px justify-center items-center"
            >
              <div
                data-v-925e8870
                className="main-filter flex-1 text-pop-title -mr-28px"
              >
                <ul
                  data-v-925e8870
                  className="main-filter-ul flex justify-center items-center leading-tight text-center break-all"
                >
                  <li
                    data-v-925e8870
                    className="main-filter-li relative mx-4 pb-1 font-bold text-13"
                  >
                    My Bets
                  </li>
                </ul>
              </div>
              <div
                onClick={() => setShowBets(false)}
                data-v-925e8870
                className="icon-close flex justify-center items-center mr-2 cursor-pointer text-global-font-on-dark text-14"
              />
            </header>
            <div
              data-v-925e8870
              className="mybet-title relative py-3 flex items-center justify-center bg-black-300 rounded-t-xl mx-3px h-40px"
            >
              <ul
                ref={containerRef}
                data-v-925e8870
                className="main-filter-ul flex justify-center items-center text-13"
              >
                {" "}
                {tabs.map((t, index) => {
                  return (
                    <li
                      onClick={() => {
                        setActiveTab(t.id);
                        setActiveIndex(index);
                      }}
                      data-v-925e8870
                      className="main-filter-li relative mx-3.5 font-bold cursor-pointer"
                    >
                      {t.label}
                      <div
                        data-v-925e8870
                        className="count inline-block px-1.5 py-1 ml-0.5 text-10 bg-secondary rounded text-global-font-on-dark font-bold"
                      >
                        {t.label == "Exchange" ? data?.length : parly?.length}
                      </div>
                    </li>
                  );
                })}
              </ul>
              <div
                data-v-925e8870
                className="tab-indicator absolute left-0 bottom-1.5 border-2 rounded-full"
              />
            </div>
          </div>
          <div
            data-v-925e8870
            className="mx-3px bg-white flex-1 flex flex-col overflow-hidden"
            isshownewmybets="true"
            isshowdetail="false"
          >
            <div className="bg-black-200 flex justify-around px-4px py-5px text-13 font-medium space-x-8px">
              <div
                onClick={() => {
                  setMatched(true);
                }}
                className={`${
                  matched ? "bg-button-unmatched-tab text-button-normal" : ""
                } py-7px px-5px rounded-3px w-full text-center`}
              >
                Matched
              </div>
              <div
                onClick={() => {
                  setMatched(false);
                }}
                className={`${
                  !matched ? "bg-button-unmatched-tab text-button-normal" : ""
                } py-7px px-5px rounded-3px w-full text-center`}
              >
                Unmatched
              </div>
            </div>
            <div className="bg-black-100 px-2 py-7px flex justify-between flex-shrink-0">
              <Dropdown />

              <div
                onClick={() => {
                  if (show) {
                    setShow(false);
                    if (activeTab == "exchange") {
                      setActive([]);
                    } else {
                      setActiveParlay([]);
                    }
                  } else {
                    setShow(true);
                    if (activeTab == "exchange") {
                      setActive(getId(data));
                    } else {
                      setActiveParlay(
                        parly?.map((res) => {
                          return res?._id;
                        })
                      );
                    }
                  }
                }}
                className="sort-Filter inline-flex items-center justify-center bg-white text-11 cursor-pointer shadow-all-button p-2 h-26px rounded-6px text-submenu"
              >
                <span className="mr-1">ALL</span>
                <i
                  className={`icon-arrow-double mt-px sm:mt-0 text-11 text-submenu scale-75 transition-transform origin-center duration-300 transform ${
                    show ? "rotate-180" : ""
                  } `}
                />
              </div>
            </div>
            <div className="overflow-y-scroll">
              <div className="mybet-content bg-secondary flex flex-col pb-0">
              {activeTab == "exchange" && (
                <section className={removeSPrefix("s-list-area s-bg-white dark:s-bg-black-800 s-flex-1 s-overflow-y-scroll hide-scrollbar")}>
                  {matched && data?.length > 0 ? (
                    data?.map((res) => {
                      return (
                        <MyBetsSingleVelkie
                          res={res}
                          active={active}
                          handle={handle}
                          time={selected == "by Time"}
                        />
                      );
                    })
                  ) : (
                    <section className="list-area rounded-b-none bg-white">
                      <div className="flex justify-center items-center py-48">
                        <div className="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
                          <div
                            alt
                            className="icon-empty text-40 text-black-300 m-auto mb-2.5"
                          />
                          <div>No Data</div>
                        </div>
                      </div>
                    </section>
                  )}
                </section>
              )}
              {activeTab == "parlay" && (
                <section
                  data-v-6feb4f8a
                  className="s-h-full s-bg-white dark:s-bg-black-800 s-p-4px s-overflow-y-scroll"
                >
                  {parly?.length > 0 && matched ? (
                    parly?.map((res) => {
                      return (
                        <section data-v-6feb4f8a className="s-mb-2 first:mt-2">
                          <div className="s-bg-black-300 dark:s-bg-black-700 s-flex s-justify-center s-items-center s-rounded-t-5px">
                            <div className="s-p-2 s-flex s-justify-between s-leading-tight s-text-12px s-w-full">
                              <span>Ref: {res?.matchBetId}</span>
                              <span>
                                {moment(res?.timeInserted).format(
                                  "DD-MM-YYYY HH:MM"
                                )}
                              </span>
                            </div>
                          </div>
                          <section className="s-divide-y s-divide-black-300 dark:s-divide-black-700">
                            <div className="s-border s-border-black-300 dark:s-border-black-700 s-border-b-0 s-divide-y s-divide-black-300 dark:s-divide-black-700">
                              <section className="s-p-2 s-flex s-items-center">
                                <div className="s-shrink-0 s-w-50px s-h-8 s-flex s-mr-2 s-font-bold s-justify-center s-items-center content-between s-bg-black-300 dark:s-bg-black-700 s-rounded-3px s-text-13px s-leading-none">
                                  <div className="dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                  <div className="dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                  <div className="dot s-w-4px s-h-4px s-bg-black-600 s-rounded-full" />
                                </div>
                                <span className="s-flex s-items-center s-text-17px s-font-bold s-break-words">
                                  {res?.bets?.length == 1
                                    ? "Single"
                                    : res?.bets?.length == 2
                                    ? "Double"
                                    : res?.bets?.length == 3
                                    ? "Treble"
                                    : "Accmulator"}
                                </span>
                              </section>
                              <section style={{borderTopWidth:'1px'}} className="s-grid s-grid-cols-3 s-divide-x s-divide-black-300 dark:s-divide-black-700">
                                <div style={{borderRight:"1px solid #dde3e5"}} className="s-p-2 s-flex-1">
                                  <div className="s-text-12px">Avg. Odds</div>
                                  <div className="s-font-bold s-leading-tight s-pt-0.5 s-text-17px">
                                    {res?.bhav}
                                  </div>
                                </div>
                                <div className="s-p-2 s-flex-1">
                                  <div className="s-text-12px">Stake (BDT)</div>
                                  <div className="s-font-bold s-leading-tight s-pt-0.5 s-text-17px">
                                    {res?.amount}
                                  </div>
                                </div>
                                <div style={{borderLeft:"1px solid #dde3e5"}} className="s-p-2 s-flex-1">
                                  <div className="s-text-12px">
                                    Profit (BDT)
                                  </div>
                                  <div className="s-font-bold s-leading-tight s-pt-0.5 s-text-17px">
                                    {res?.profitAmount}
                                  </div>
                                </div>
                              </section>
                              <section className="s-divide-y s-divide-black-300 dark:s-divide-black-700 s-p-2 s-text-12px">
                                <span>
                                  Will be <strong>keep</strong> at in-play
                                </span>
                              </section>
                            </div>
                            {activeParlay?.includes(res?._id) &&
                              res?.bets?.map((item) => {
                                return (
                                  <section
                                    style={{
                                      borderRight: "1px solid #dde3e5",
                                      borderLeft: "1px solid #dde3e5",
                                    }}
                                  >
                                    <article>
                                      <div className="s-flex s-justify-center s-items-center s-bg-parlay-betSlip-content-header dark:s-bg-black-900">
                                        <div className="s-p-2 s-leading-tight s-text-12px s-w-full">
                                          <span className="s-whitespace-pre-wrap">
                                            {betCheckObj[item?.eventType]}
                                          </span>
                                          <i className="s-icon-triangle-black-600 s-inline-block" />
                                          <span>
                                            <strong>{item?.matchName}</strong>
                                          </span>
                                          <i className="s-icon-triangle-black-600 s-inline-block" />
                                          <span>{item?.fancyName}</span>
                                        </div>
                                      </div>
                                      <section className="s-bg-parlay-betSlip-content-background-light dark:s-bg-parlay-betSlip-content-background-dark s-p-2 s-flex s-justify-between s-items-center">
                                        <div className="s-flex s-justify-center s-items-center">
                                          <div className="s-shrink-0 s-w-50px s-h-8 s-flex s-mr-2 s-font-bold s-justify-center s-items-center s-content-between s-bg-black-300 dark:s-bg-black-700 s-rounded-3px s-text-13px">
                                            <div className="s-dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                            <div className="s-dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                            <div className="s-dot s-w-4px s-h-4px s-bg-black-600 s-rounded-full" />
                                          </div>
                                          <div className="s-font-bold s-text-17px">
                                            {item?.runnerName}
                                          </div>
                                        </div>
                                        <div className="s-bg-parlay-betInfo-light dark:s-bg-parlay-betInfo-dark dark:s-bg-global-font-default-dark s-text-15px s-px-3 s-py-2 s-rounded-4px s-font-bold">
                                          {item?.bhav}
                                        </div>
                                      </section>
                                    </article>
                                  </section>
                                );
                              })}
                          </section>
                          <footer
                            onClick={() => {
                              if (activeParlay.includes(res?._id)) {
                                setActiveParlay(
                                  activeParlay?.filter((obj) => {
                                    return obj != res?._id;
                                  })
                                );
                              } else {
                                setActiveParlay([...activeParlay, res?._id]);
                              }
                            }}
                          >
                            <div
                              className={`${
                                activeParlay.includes(res?._id)
                                  ? "s-bg-black-400 dark:s-bg-black-700"
                                  : ""
                              } s-h-2 s-rounded-b-lg s-transition-colors s-duration-500 s-bg-black-300 dark:s-bg-black-700`}
                            />
                            <div
                          
                              className={`${
                                activeParlay.includes(res?._id)
                                  ? "s-bg-black-400"
                                  : ""
                              } s-h-4 s-rounded-b-lg s-w-90px s-mx-auto s-flex s-justify-center s-transition-colors s-duration-500 s-bg-black-300 dark:s-bg-black-700`}
                            >
                              {activeParlay.includes(res?._id) ? (
                                <IoIosArrowUp   style={{marginTop:"-5px"}} size={20} />
                              ) : (
                                <IoIosArrowDown   style={{marginTop:"-5px"}} size={20} />
                              )}
                              {/* <span
                                className={`${
                                  activeParlay.includes(res?._id)
                                    ? "s-transform s-rotate-180"
                                    : ""
                                } s-icon-arrow-down-sencodary s-text-14px s-relative -s-top-1 s-text-black dark:s-text-global-font-default-dark s-transition-transform s-origin-center s-duration-300`}
                              /> */}
                            </div>
                          </footer>
                        </section>
                      );
                    })
                  ) : (
                    <section className="list-area rounded-b-none bg-white">
                      <div className="flex justify-center items-center py-48">
                        <div className="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
                          <div
                            alt
                            className="icon-empty text-40 text-black-300 m-auto mb-2.5"
                          />
                          <div>No Data</div>
                        </div>
                      </div>
                    </section>
                  )}
                </section>
              )}
              </div>
              {/* <section className="list-area rounded-b-none bg-white">
                  <div className="flex justify-center items-center py-48">
                    <div className="pt-6 px-7 pb-5 bg-white text-center text-black-700 text-base rounded-xl leading-tight">
                      <div
                        alt
                        className="icon-empty text-40 text-black-300 m-auto mb-2.5"
                      />
                      <div>No Data</div>
                    </div>
                  </div>
                </section> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBetsVelkie;
